"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sticker = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var Sticker = function Sticker(props) {
  var stickerName = props.stickerName,
    stickerUrl = props.stickerUrl,
    className = props.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('sticker-container'), className)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: stickerUrl,
    alt: stickerName
  }));
};
exports.Sticker = Sticker;